import { useEffect, useRef } from 'react';
import { useUIStore } from '@/stores/uiStore';
import { gsap } from 'gsap';

const Preloader = () => {
  const preloaderRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);
  const progressRef = useRef<HTMLDivElement>(null);
  const { setPreloaderVisible } = useUIStore();

  useEffect(() => {
    const preloader = preloaderRef.current;
    const logo = logoRef.current;
    const progress = progressRef.current;

    if (!preloader || !logo || !progress) return;

    // Animate logo
    gsap.fromTo(
      logo,
      {
        scale: 0,
        rotation: 0,
        opacity: 0,
      },
      {
        scale: 1,
        rotation: 360,
        opacity: 1,
        duration: 1.5,
        ease: 'back.out(1.7)',
      }
    );

    // Animate progress
    gsap.to(progress, {
      width: '100%',
      duration: 2,
      ease: 'power2.out',
    });

    // Hide preloader
    const timer = setTimeout(() => {
      gsap.to(preloader, {
        opacity: 0,
        duration: 0.5,
        onComplete: () => {
          setPreloaderVisible(false);
        },
      });
    }, 2000);

    return () => clearTimeout(timer);
  }, [setPreloaderVisible]);

  return (
    <div
      ref={preloaderRef}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-brand-purple-dark dark:bg-dark-primary"
    >
      <div className="flex flex-col items-center gap-8">
        <div
          ref={logoRef}
          className="w-32 h-32 rounded-full bg-gradient-to-br from-brand-purple-base to-brand-orange-base p-4 flex items-center justify-center"
        >
          <img
            src="/assets/images/elhamylab1024.jpeg"
            alt="ElhamyLabs Logo"
            className="w-full h-full object-contain rounded-full"
          />
        </div>
        <div className="w-64 h-1 bg-brand-purple-light/20 rounded-full overflow-hidden">
          <div
            ref={progressRef}
            className="h-full bg-gradient-to-r from-brand-orange-base to-brand-purple-base rounded-full"
            style={{ width: '0%' }}
          />
        </div>
      </div>
    </div>
  );
};

export default Preloader;

